"use strict";exports.throttle=function(t,r){var e,n=!1;return function(){for(var o=[],i=0;i<arguments.length;i++)o[i]=arguments[i];if(!n){var u=t.apply(void 0,o);return n=!0,clearTimeout(e),e=setTimeout((function(){n=!1}),r),u}}};
//# sourceMappingURL=throttle.cjs.map
